const WRITER_LEVELS = [
  {
    value: 'Junior',
    label: 'Junior',
    sortingPosition: 2,
  },
  {
    value: 'Senior',
    label: 'Senior',
    sortingPosition: 1,
  },
  {
    value: 'Premium',
    label: 'Premium',
    sortingPosition: 0,
  },
];

module.exports = WRITER_LEVELS;
